module.exports = __webpack_public_path__ + "media/images/application/icons/logout-white-ea74f42bcdde18d4f0755ffd94587a4e.svg";